(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-artist-bio"] && !Shopify.designMode) return;
  try {
    class ArtistBioToggle extends HTMLElement {
    #MOBILE_BREAKPOINT = 750;
    #TRUNCATION_THRESHOLD = 280;

    connectedCallback() {
      this.#content = this.querySelector('[ref="content"]');
      this.#text = this.querySelector('[ref="text"]');
      this.#toggle = this.querySelector('[ref="toggle"]');
      this.#label = this.querySelector('[ref="label"]');

      if (!this.#content || !this.#text || !this.#toggle) return;

      this.#toggle.addEventListener('click', () => this.#handleToggle());
      this.#resizeObserver = new ResizeObserver(() => this.#evaluate());
      this.#resizeObserver.observe(document.documentElement);
      this.#evaluate();
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
    }

    // Whether truncation applies for the current viewport/content, independent
    // of whether the user has chosen to expand it.
    #evaluate() {
      const isMobile = window.innerWidth < this.#MOBILE_BREAKPOINT;
      const textLength = (this.#text.textContent || '').length;

      this.#needsTruncation = isMobile && textLength > this.#TRUNCATION_THRESHOLD;
      this.#toggle.hidden = !this.#needsTruncation;
      this.#render();
    }

    #handleToggle() {
      this.#expanded = !this.#expanded;
      this.#render();
    }

    // Applies the current state without clobbering the user's expand choice.
    #render() {
      const truncated = this.#needsTruncation && !this.#expanded;
      this.#content.classList.toggle('custom-artist-bio__content--truncated', truncated);
      this.#toggle.setAttribute('aria-expanded', String(!truncated));
      this.#label.textContent = truncated ? 'Read More' : 'Read Less';
    }

    #content;
    #text;
    #toggle;
    #label;
    #resizeObserver;
    #expanded = false;
    #needsTruncation = false;
  }

  if (!customElements.get('artist-bio-toggle')) {
    customElements.define('artist-bio-toggle', ArtistBioToggle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-asn-shipping"] && !Shopify.designMode) return;
  try {
    class AsnShippingStatus extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[ref="variantData"]');
      if (!dataEl) return;

      try {
        this.#store = JSON.parse(dataEl.textContent);
      } catch {
        return;
      }

      this.#sectionId = this.dataset.sectionId;
      this.#showAsn = this.dataset.showAsn === 'true';
      this.#showEstimate = this.dataset.showEstimate === 'true';
      this.#asnStatusEl = this.querySelector('[ref="asnStatus"]');
      this.#estimateEl = this.querySelector('[ref="shippingEstimate"]');

      /* Use the same state for direct variant links and subsequent size changes. */
      this.#updateForVariant(this.dataset.variantId);

      /* Listen for variant changes. Horizon dispatches 'variant:update' from the
         variant picker; the new variant is on event.detail.resource. We scope
         naturally by listening on the closest section, mirroring the theme's own
         components (e.g. product-inventory.js). */
      this.#section = this.closest('.shopify-section, dialog');
      const scope = this.#section ?? document;
      scope.addEventListener('variant:update', this.#onVariantChange);

      /* Safety net: re-sync the pre-order property from the form's currently selected
         variant id at submit time, in the capture phase — before product-form.js builds
         its FormData. This guarantees the property is correct no matter how (or whether)
         the variant changed, including single-variant products that never emit
         'variant:update', and survives any missed/late event or DOM morph. */
      scope.addEventListener('submit', this.#onFormSubmit, true);
    }

    disconnectedCallback() {
      const scope = this.#section ?? document;
      scope.removeEventListener('variant:update', this.#onVariantChange);
      scope.removeEventListener('submit', this.#onFormSubmit, true);
    }

    /* Arrow field so `this` is bound and the reference is stable for removeEventListener.
       (A private *method* is non-writable, so it can't be re-bound in connectedCallback.) */
    #onVariantChange = (e) => {
      const variant = e.detail?.resource;
      if (variant?.id != null) {
        this.#updateForVariant(String(variant.id));
      } else {
        /* No resolvable variant (e.g. a sold-out / non-existent option combination
           emits resource: null). Never leave stale ASN or shipping info on screen
           for an unpurchasable selection. */
        this.#hideAll();
      }
    };

    /* Capture-phase submit handler on the section. Runs before product-form.js reads
       the form's FormData, so the pre-order property is always accurate at add-to-cart
       time — the authoritative source being the form's own selected variant id. */
    #onFormSubmit = (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      /* Only act on the product form this block's property is bound to. */
      const propEl = this.querySelector('[ref="asnProperty"]');
      if (!propEl || propEl.form !== form) return;
      const variantId = form.querySelector('input[name="id"]')?.value;
      this.#syncPreorderProperty(variantId ? this.#store.variants[String(variantId)] : null);
    };

    /* Single source of truth for the pre-order line item property. Re-queries the input
       each call so it survives DOM morphs. A disabled input is omitted from the cart
       FormData, so non-pre-order variants send nothing. Returns whether this is a pre-order. */
    #syncPreorderProperty(data) {
      const el = this.querySelector('[ref="asnProperty"]');
      if (!el) return false;
      const isPreorder = !!(
        data &&
        data.available &&
        data.hasAsn &&
        data.shipDate &&
        data.shipDate !== 'Now' &&
        this.#isFutureDate(data.shipDate)
      );
      if (isPreorder) {
        el.value = 'Ships: ' + this.#formatDate(data.shipDate);
        el.disabled = false;
      } else {
        el.value = '';
        el.disabled = true;
      }
      return isPreorder;
    }

    /* Hide all ASN/shipping UI and clear the pre-order property. Used when the
       selected variant is sold out or the option combination doesn't resolve. */
    #hideAll() {
      if (this.#asnStatusEl) this.#asnStatusEl.hidden = true;
      if (this.#estimateEl) this.#estimateEl.hidden = true;
      this.#syncPreorderProperty(null);
    }

    #updateForVariant(variantId) {
      const data = this.#store.variants[variantId];

      /* Pre-order = future incoming inventory (ASN), not already in stock. Syncing the
         line item property is the single source of truth and also tells us whether this
         is a pre-order (drives the badge, independent of the display toggle). */
      const isPreorder = this.#syncPreorderProperty(data);

      /* The status badge shows the pre-order case only when the display toggle is on.
         When it's visible, the shipping estimate is suppressed to avoid duplicate messaging. */
      const asnBadgeVisible = this.#showAsn && isPreorder;

      /* ── ASN status badge ── */
      if (this.#showAsn && this.#asnStatusEl) {
        if (!asnBadgeVisible) {
          this.#asnStatusEl.hidden = true;
        } else {
          this.#asnStatusEl.hidden = false;
          const fmt = this.#formatDate(data.shipDate);
          this.#asnStatusEl.innerHTML =
            '<div class="custom-asn-shipping__badge custom-asn-shipping__badge--incoming">' +
            '<span class="custom-asn-shipping__icon" aria-hidden="true">📦</span>' +
            '<span>Ships ' + fmt + '</span></div>';
        }
      }

      /* ── Shipping estimate — hidden when the ASN badge is showing ── */
      if (this.#showEstimate && this.#estimateEl) {
        if (!data || !data.available || asnBadgeVisible) {
          this.#estimateEl.hidden = true;
          return;
        }

        this.#estimateEl.hidden = false;
        let message = '';
        let modifier = '';

        if (this.#store.onDemand) {
          /* On-demand products always show made-to-order message */
          message = 'Made to order! Ships out in 5 days';
          modifier = ' custom-asn-shipping__message--on-demand';
        } else if (data.hasAsn && data.shipDate && data.shipDate !== 'Now' && this.#isFutureDate(data.shipDate)) {
          /* Has ASN with future date — in production */
          message = 'In Production. Ships on ' + this.#formatDate(data.shipDate);
          modifier = ' custom-asn-shipping__message--asn';
        } else if (data.hasAsn && data.shipDate !== 'Now') {
          message = 'Expected ship date to be confirmed.';
          modifier = ' custom-asn-shipping__message--asn';
        } else {
          /* In stock or past ASN — dynamic day/time shipping message */
          message = this.#getShippingMessage();
          modifier = '';
        }

        this.#estimateEl.innerHTML =
          '<p class="custom-asn-shipping__message' + modifier + '">' + message + '</p>';
      }
    }

    #getShippingMessage() {
      const now = new Date();
      /* Convert to EST (UTC-5) */
      const est = new Date(
        now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
        now.getUTCHours() - 5, now.getUTCMinutes(), now.getUTCSeconds()
      );
      const weekday = est.getDay();
      const hour = est.getHours();

      /* Mon–Fri before 3pm EST → ships today */
      if (weekday >= 1 && weekday < 6) {
        return hour < 15
          ? 'Ships today if ordered by 3pm EST.'
          : 'Ships tomorrow if ordered today.';
      }
      /* Weekend → ships Monday */
      return 'Ships Monday if ordered today.';
    }

    #isFutureDate(dateStr) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const target = new Date(dateStr + 'T00:00:00');
      return target >= today;
    }

    #formatDate(dateStr) {
      const d = new Date(dateStr + 'T00:00:00');
      return d.toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric'
      });
    }

    #store;
    #sectionId;
    #showAsn;
    #showEstimate;
    #asnStatusEl;
    #estimateEl;
    #section;
  }

  if (!customElements.get('asn-shipping-status')) {
    customElements.define('asn-shipping-status', AsnShippingStatus);
  }
  } catch(e) { console.error(e); }
})();

})();
